/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Api
 * Unfold Agentic Journaling API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnswerRequest,
  CreateCustomPlaybookRequest,
  CreateSessionRequest,
  HealthStatus,
  Journal,
  JournalSummary,
  Playbook,
  Session
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a new journaling session from a link or text
 */
export const getCreateSessionUrl = () => {




  return `/api/sessions`
}

export const createSession = async (createSessionRequest: CreateSessionRequest, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getCreateSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSessionRequest,)
  }
);}




export const getCreateSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionRequest>}, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, {data: BodyType<CreateSessionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = BodyType<CreateSessionRequest>
    export type CreateSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create a new journaling session from a link or text
 */
export const useCreateSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        {data: BodyType<CreateSessionRequest>},
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options));
    }

/**
 * @summary Get session by ID
 */
export const getGetSessionUrl = (id: string,) => {




  return `/api/sessions/${id}`
}

export const getSession = async (id: string, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getGetSessionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = (id: string,) => {
    return [
    `/api/sessions/${id}`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = ErrorType<unknown>


/**
 * @summary Get session by ID
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSessionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Answer the agent's personalization question
 */
export const getAnswerAgentQuestionUrl = (id: string,) => {




  return `/api/sessions/${id}/answer`
}

export const answerAgentQuestion = async (id: string,
    answerRequest: AnswerRequest, options?: RequestInit): Promise<Journal> => {

  return customFetch<Journal>(getAnswerAgentQuestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      answerRequest,)
  }
);}




export const getAnswerAgentQuestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerAgentQuestion>>, TError,{id: string;data: BodyType<AnswerRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof answerAgentQuestion>>, TError,{id: string;data: BodyType<AnswerRequest>}, TContext> => {

const mutationKey = ['answerAgentQuestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof answerAgentQuestion>>, {id: string;data: BodyType<AnswerRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  answerAgentQuestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnswerAgentQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof answerAgentQuestion>>>
    export type AnswerAgentQuestionMutationBody = BodyType<AnswerRequest>
    export type AnswerAgentQuestionMutationError = ErrorType<unknown>

    /**
 * @summary Answer the agent's personalization question
 */
export const useAnswerAgentQuestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerAgentQuestion>>, TError,{id: string;data: BodyType<AnswerRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof answerAgentQuestion>>,
        TError,
        {id: string;data: BodyType<AnswerRequest>},
        TContext
      > => {
      return useMutation(getAnswerAgentQuestionMutationOptions(options));
    }

/**
 * @summary List all journal entries
 */
export const getListJournalsUrl = () => {




  return `/api/journals`
}

export const listJournals = async ( options?: RequestInit): Promise<JournalSummary[]> => {

  return customFetch<JournalSummary[]>(getListJournalsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJournalsQueryKey = () => {
    return [
    `/api/journals`
    ] as const;
    }


export const getListJournalsQueryOptions = <TData = Awaited<ReturnType<typeof listJournals>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listJournals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJournalsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJournals>>> = ({ signal }) => listJournals({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJournals>>, TError, TData> & { queryKey: QueryKey }
}

export type ListJournalsQueryResult = NonNullable<Awaited<ReturnType<typeof listJournals>>>
export type ListJournalsQueryError = ErrorType<unknown>


/**
 * @summary List all journal entries
 */

export function useListJournals<TData = Awaited<ReturnType<typeof listJournals>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listJournals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListJournalsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get a specific journal entry
 */
export const getGetJournalUrl = (id: string,) => {




  return `/api/journals/${id}`
}

export const getJournal = async (id: string, options?: RequestInit): Promise<Journal> => {

  return customFetch<Journal>(getGetJournalUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJournalQueryKey = (id: string,) => {
    return [
    `/api/journals/${id}`
    ] as const;
    }


export const getGetJournalQueryOptions = <TData = Awaited<ReturnType<typeof getJournal>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJournal>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJournalQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournal>>> = ({ signal }) => getJournal(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJournal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJournalQueryResult = NonNullable<Awaited<ReturnType<typeof getJournal>>>
export type GetJournalQueryError = ErrorType<unknown>


/**
 * @summary Get a specific journal entry
 */

export function useGetJournal<TData = Awaited<ReturnType<typeof getJournal>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJournal>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJournalQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete a journal entry
 */
export const getDeleteJournalUrl = (id: string,) => {




  return `/api/journals/${id}`
}

export const deleteJournal = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteJournalUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteJournalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJournal>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJournal>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteJournal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJournal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteJournal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJournalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJournal>>>

    export type DeleteJournalMutationError = ErrorType<unknown>

    /**
 * @summary Delete a journal entry
 */
export const useDeleteJournal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJournal>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJournal>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteJournalMutationOptions(options));
    }

/**
 * @summary List curated and community YouTube playbooks (shared library)
 */
export const getListPlaybooksUrl = () => {




  return `/api/library`
}

export const listPlaybooks = async ( options?: RequestInit): Promise<Playbook[]> => {

  return customFetch<Playbook[]>(getListPlaybooksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlaybooksQueryKey = () => {
    return [
    `/api/library`
    ] as const;
    }


export const getListPlaybooksQueryOptions = <TData = Awaited<ReturnType<typeof listPlaybooks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlaybooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlaybooksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlaybooks>>> = ({ signal }) => listPlaybooks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlaybooks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlaybooksQueryResult = NonNullable<Awaited<ReturnType<typeof listPlaybooks>>>
export type ListPlaybooksQueryError = ErrorType<unknown>


/**
 * @summary List curated and community YouTube playbooks (shared library)
 */

export function useListPlaybooks<TData = Awaited<ReturnType<typeof listPlaybooks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlaybooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlaybooksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Add a YouTube video to the shared community library
 */
export const getCreateCustomPlaybookUrl = () => {




  return `/api/library/custom`
}

export const createCustomPlaybook = async (createCustomPlaybookRequest: CreateCustomPlaybookRequest, options?: RequestInit): Promise<Playbook> => {

  return customFetch<Playbook>(getCreateCustomPlaybookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCustomPlaybookRequest,)
  }
);}




export const getCreateCustomPlaybookMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomPlaybook>>, TError,{data: BodyType<CreateCustomPlaybookRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomPlaybook>>, TError,{data: BodyType<CreateCustomPlaybookRequest>}, TContext> => {

const mutationKey = ['createCustomPlaybook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomPlaybook>>, {data: BodyType<CreateCustomPlaybookRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomPlaybook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomPlaybookMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomPlaybook>>>
    export type CreateCustomPlaybookMutationBody = BodyType<CreateCustomPlaybookRequest>
    export type CreateCustomPlaybookMutationError = ErrorType<void>

    /**
 * @summary Add a YouTube video to the shared community library
 */
export const useCreateCustomPlaybook = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomPlaybook>>, TError,{data: BodyType<CreateCustomPlaybookRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomPlaybook>>,
        TError,
        {data: BodyType<CreateCustomPlaybookRequest>},
        TContext
      > => {
      return useMutation(getCreateCustomPlaybookMutationOptions(options));
    }

/**
 * @summary Remove a community playbook you added (optional API)
 */
export const getDeleteCustomPlaybookUrl = (id: string,) => {




  return `/api/library/custom/${id}`
}

export const deleteCustomPlaybook = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomPlaybookUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomPlaybookMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomPlaybook>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomPlaybook>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCustomPlaybook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomPlaybook>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomPlaybook(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomPlaybookMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomPlaybook>>>

    export type DeleteCustomPlaybookMutationError = ErrorType<void>

    /**
 * @summary Remove a community playbook you added (optional API)
 */
export const useDeleteCustomPlaybook = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomPlaybook>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomPlaybook>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCustomPlaybookMutationOptions(options));
    }

/**
 * @summary Start a session from a library playbook
 */
export const getStartPlaybookUrl = (id: string,) => {




  return `/api/library/${id}/start`
}

export const startPlaybook = async (id: string, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getStartPlaybookUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartPlaybookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPlaybook>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPlaybook>>, TError,{id: string}, TContext> => {

const mutationKey = ['startPlaybook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPlaybook>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  startPlaybook(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPlaybookMutationResult = NonNullable<Awaited<ReturnType<typeof startPlaybook>>>

    export type StartPlaybookMutationError = ErrorType<unknown>

    /**
 * @summary Start a session from a library playbook
 */
export const useStartPlaybook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPlaybook>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startPlaybook>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getStartPlaybookMutationOptions(options));
    }

